import { transition, trigger } from "@angular/animations";
import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { setTheme } from "ngx-bootstrap/utils";
import { slideLeft, slideRight } from "./shared/animations";

/**
 * This class represents the main application component. Within the @Routes annotation is the configuration of the
 * applications routes, configuring the paths for the lazy loaded components (HomeComponent, AboutComponent).
 */
@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterModule],
  templateUrl: "app.component.html",
  animations: [
    trigger("routerAnimations", [
      // transition('planning => domain', slideRight),
      transition("planning => domain", slideLeft),
      transition("domain => planning", slideRight),
    ]),
  ],
})
export class AppComponent {
  constructor(translate: TranslateService) {
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    translate.use("nl");
    setTheme("bs4");
  }

  prepareRouteTransition(outlet) {
    const animation = outlet.activatedRouteData["animation"] || {};
    return animation["value"] || null;
  }
}
